<template>
  <div class="pioneer6-compare-switcher">
    <p class="compare-title">{{ sectionData.field_1 }}</p>
    <div class="series-header">
      <div class="header-wrapper">
        <p class="series series6"
          :class="{ active: selectedSeries === 'Series 6', inactive: selectedSeries !== 'Series 6' }" @click="showField2">
          Series 6</p>
        <p class="series series5"
          :class="{ active: selectedSeries === 'Series 5', inactive: selectedSeries !== 'Series 5' }" @click="showField3">
          Series 5</p>
      </div>
    </div>
    <div class="content-section"  :class="{ pioneer6content: selectedSeries === 'Series 6', pioneer5content: selectedSeries !== 'Series 6' }">
      <div class="comparision-img">
        <img v-if="selectedSeries === 'Series 6'" :src="sectionData.field_3" alt="pioneer6">
        <img v-if="selectedSeries === 'Series 5'" :src="sectionData.field_2" alt="pioneer5">
      </div>
      <div class="comparision-header">
        <p v-if="selectedSeries === 'Series 5'">Pioneer Series 5</p>
        <p v-else>Pioneer Series 6</p>
      </div>
      <div class="table-content">
        <div class="series-comparison" v-for="(sectionitem, index) in sectionData.items" :key="index">
          <div class="comparision-wrapper">
            <p>{{ sectionitem.field_1 }}</p>
            <div v-if="selectedSeries === 'Series 5'">
              <img v-if="sectionitem.field_3 == 'Yes'" class="icon check-icon" src="https://assets.rhinorack.com/zwifloc/checkmark.png" alt="checked">
              <img v-else class="icon cross-icon" src="https://assets.rhinorack.com/zwifloc/crossmark.png" alt="crossed">
            </div>
            <div v-else>
              <img v-if="sectionitem.field_2 == 'Yes'" class="icon check-icon" src="https://assets.rhinorack.com/zwifloc/checkmark.png" alt="checked">
              <img v-else class="icon cross-icon" src="https://assets.rhinorack.com/zwifloc/crossmark.png" alt="crossed">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "pioneer6-comparison",
  props: {
    section: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      sectionData: {
        items: [],
      },
      selectedSeries: "Series 6",
    };
  },
  methods: {
    showField2() {
      this.selectedSeries = "Series 6";
    },
    showField3() {
      this.selectedSeries = "Series 5";
    },
  },
  mounted() {
    try {
      this.sectionData = JSON.parse(this.section);
    } catch (error) {
      console.error("Error parsing section JSON:", error);
    }
  },
};
</script>

<style lang="scss" scoped>
.pioneer6-compare-switcher {
  text-align: center;
  padding: 40px 0;

  .compare-title {
    color: #0F1720;
    font-family: 'trim-medium';
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0.46px;
    line-height: 22px;
    text-align: center;
  }

  .series-header {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 19px;

    .header-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      border-radius: 26px;
      background-color: #F6F6F6;
      height: 50px;
      width: 281px;

      .series {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 1rem;
      }

      .active {
        height: 42px;
        width: 134px;
        border-radius: 22px;
        background-color: #FFFFFF;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.12);
      }

      .inactive {
        height: 42px;
        width: 134px;
        border-radius: 22px;
        background-color: #F6F6F6;
      }
    }

  }


.pioneer6content{
  background-color: rgba(0, 92, 185, 0.08);
  border-radius: 8px;
}
  .content-section {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 15px;
    padding: 40px;

    .comparision-img {
      img {
        max-height: 144px;
        max-width: 268.8px;
      }
    }

    .comparision-header {
      color: #0F1720;
      font-family: 'trim-medium';
      font-size: 24px;
      font-weight: 500;
      letter-spacing: 0.46px;
      line-height: 22px;
      text-align: center;
    }

    .table-content {
      width: 100%;
      .series-comparison {
        .comparision-wrapper {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: baseline;
          gap: 100px;
          text-align: left;

          @media screen and (max-width: 425px) {
            gap: 55px;
          }

          p{
            color: #0F1720;
            font-family: 'trim-light';
            font-size: 18px;
            font-weight: 500;
          }

          .icon{
            max-width: 50px;
          }

        }
      }
    }
  }
}
</style>
